<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";
import {sanPhamSenModel} from "@/models/sanPhamSenModel";
import Multiselect from "vue-multiselect";
export default {
  page: {
    title: "Quản lý sản phẩm sen",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader, vueDropzone: vue2Dropzone,Multiselect
  },
  data() {
    return {
      title: "Quản lý sản phẩm sen",
      items: [
        {
          text: "Quản lý sản phẩm sen",
          href: "/quan-ly-diem-ban",
          // active: true,
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      data: [],
      showModal: false,
      showModalSlider: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: sanPhamSenModel.baseJson(),
      listRole: [],
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      images: null,
      fields: [
        {
          key: 'STT', label: 'STT',
          class: "text-center td-stt",
          tdClass: 'align-middle',
          thClass: 'hidden-sortable'
        },
        {
          key: "name",
          label: "Tên",
          class: "text-center",
          thClass: 'hidden-sortable'
        },
        {
          key: "doanhNghiepSanXuat",
          label: "Doanh nghiệp sản xuất",
          class: "text-center",
          thClass: 'hidden-sortable'
        },
        {
          key: "avartar",
          label: "Ảnh",
          class: "text-center",
          thClass: 'hidden-sortable'
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: "text-center",
          thStyle: {width: '100px', minWidth: '60px'},
          thClass: 'hidden-sortable'
        }
      ],
      listFileSilder : [],
      url : `${process.env.VUE_APP_API_URL}filesminio/view/`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}filesminio/upload`,
        acceptedFiles: ".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx, .zip",
        thumbnailHeight: 100,
        thumbnailWidth: 300,
        maxFiles: 30,
        maxFilesize: 50,
        maxFileSizeInMB:50,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true
      },
      image: "",
      file: "",
      urlFile:`${process.env.VUE_APP_API_URL}filesminio/view`,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|','style',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'codeBlock',
            'alignment',
            'ckbox',
            'fontColor',
            'fontBackgroundColor',
            'fontFamily',
            'fontSize',
            'formatPainter',
            'highlight',
            'htmlEmbed',
            'tableOfContents',
            'undo',
            'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "filesminio/uploadCK",
          headers: {
            'Authorization': 'optional_token'
          },
        },
        image: {
          toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],
        },

      },
      listDoanhNghiep: [],
    };
  },
  computed: {
    //Validations
    rules(){
      return{
        name:{required},
        mieuTa:{required},
        thanhPhan:{required},
        thuongHieu:{required},
        doanhNghiepSanXuat:{required},
        danhGia:{required},
        link:{required},
      }
    }
  },
  validations: {
    model: {
      name:{required},
      mieuTa:{required},
      thanhPhan:{required},
      thuongHieu:{required},
      doanhNghiepSanXuat:{required},
      danhGia:{required},
      link:{required},
    },
  },
  created() {
    this.getListDoanhNghiep()
    const user = {
      id: 1,
      name: 'Victory Osayi',
      is_editor: true,
      is_admin: false,
      // you can have role based permission list or access control list possibly from database
      permissions: [
        'manage-BIENBAN-656442f5106c43a04bbadfaa', 
        'create-BIENBAN-656442f5106c43a04bbadfaa',
        'update-BIENBAN-656442f5106c43a04bbadfaa',
        'delete-BIENBAN-656442f5106c43a04bbadfaa'
      ]
    }
  },
  watch: {
    showModalSlider(status) {
      if (status == false) this.model = sanPhamSenModel.baseJson() ;
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
  },
  methods: {
    async getListDoanhNghiep(){
      await  this.$store.dispatch("doanhNghiepStore/getAll").then((res) =>{
        this.listDoanhNghiep = res.data || [];
      })
    },
    uploadFile(file,response) {
      let fileSuccess = response.data;
      console.log('log suscess', response.data)
      if (response.code == 0){
        this.model.file.push({
          fileId: fileSuccess.fileId,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext,
          path: fileSuccess.path
        });
      }
      console.log('log model file', this.model.file)

    },
    removeThisFile(files, error, xhr) {
      let fileCongViec = JSON.parse(files.xhr.response);
      if (fileCongViec.data && fileCongViec.data.fileId) {
        let idFile = fileCongViec.data.fileId;
        let resultData = this.model.file.filter(x => {
          return x.fileId != idFile;
        })
        this.model.file = resultData;
        //  console.log('log model file remove', this.model.files)
      }
    },
    sendingEvent(file, xhr, formData) {
      formData.append("files", file);
    },



    async handleSubmitSlider(e) {
      e.preventDefault();
      this.submitted = true;
      console.log("ID: ", this.model);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model._id != 0 &&
            this.model._id != null &&
            this.model._id
        ) {
          console.log("LOG USER UPDATE NE : " , this.model)
          if (this.model == null || (this.model != null && this.model.file == null)) {
            this.$store.dispatch("snackBarStore/addNotify", {
              message: "Vui lòng chọn file trước khi lưu ",
              code: 20,
            });
            loader.hide();
            return;
          }else{
            await this.$store.dispatch("sanPhamSenStore/update", this.model).then((res) => {
              if (res.code === 0) {
                this.showModalSlider = false;
                this.$refs.tblList.refresh();
                this.model = sanPhamSenModel.baseJson();
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                message: res.message,
                code: res.code,
              });
            });
          }

          // Update model
        } else {
          // Create model
          console.log("LOG USER CREATE NE : " , this.model)
          if (this.model == null || (this.model != null && this.model.file == null)) {
            this.$store.dispatch("snackBarStore/addNotify", {
              message: "Vui lòng chọn file trước khi lưu ",
              code: 20,
            });
            loader.hide();
            return;
          }else{
            await this.$store.dispatch("sanPhamSenStore/create", this.model).then((res) => {
              if (res.code === 0) {
                this.fnGetList();
                this.showModalSlider = false;
                this.model={}
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                message: res.message,
                code: res.code,
              });
            });
          }
        }
        loader.hide();
      }
      this.submitted = false;
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("sanPhamSenStore/delete",{id :  this.model.id}).then((res) => {
          if (res.code===0) {
            this.fnGetList();
            this.model = sanPhamSenModel.baseJson();
            this.showDeleteModal = false;
          }
          var a = {
            message: res.message,
            code: res.code
          };
          // console.log("LOG A : " ,a)
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code
          });
        });
      }
    },
    async handleUpdate(id) {
      await this.$store.dispatch("sanPhamSenStore/getById", {id : id}).then((res) => {
        if (res.code===0) {
          console.log(res)
          this.model = sanPhamSenModel.toJson(res.data);
          this.showModalSlider = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        }
      });
    },

    myProvider (ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortDesc: true,
      }
      this.loading = true
      try {
        let promise =  this.$store.dispatch("sanPhamSenStore/getPagingParams", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    getColorWithExtFile(ext) {
      if (ext == '.png' || ext == '.jpg'|| ext == '.jpeg' )
        return 'text-danger';

    },

    getIconWithExtFile(ext) {
      if (ext == '.png' || ext == '.jpg'|| ext == '.jpeg')
        return 'mdi mdi-file-image-outline';
    },
    deleteImage(){
      if (this.model != null && this.model.avartar != null)
      {
        console.log("LOG this.model : ", this.model)
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.model.avartar.fileId}`).then((response) => {
          this.model.avartar = null;
          console.log('log model file remove', this.model.avartar);
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });
      }
    },
    deleteFile(id) {
      let resultData = this.model.file.filter(x => {
        return x.fileId !=id;
      })
      this.model.file = resultData;
      console.log('log model file remove', this.model.file)
      axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/`+id).then((response) => {
        console.log('log model file remove', this.model.file);
      }).catch((error) => {
        // Handle error here
        console.error('Error deleting file:', error);
      });
    },
    async upload() {
      if (this.model != null && this.model.avartar != null)
      {
        console.log("LOG this.model : ", this.model)
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.model.avartar.fileId}`).then((response) => {
          this.model.files = null;
          console.log('log model file remove', this.model.files);
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });
      }

      if ( event.target &&  event.target.files.length > 0 ) {
        const formData = new FormData()
        formData.append('files', event.target.files[0])
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/UploadFileImage`,formData).then((response) => {
          // console.log("LOG UPDATE : ", response);
          let resultData = response.data
          if (response.data.code == 0){
            this.model.avartar={
              fileId: resultData.data.fileId,
              fileName: resultData.data.fileName,
              ext: resultData.data.ext,
              path: resultData.data.path
            };
            console.log("LOG UPDATE : ", this.model);
          }
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });

      }
    },

  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        v-model="filter"
                        type="text"
                        class="form-control"
                        placeholder="Tìm kiếm ..."
                    />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <b-button
                      type="button"
                      class="btn cs-btn-primary btn-rounded mb-2 me-2"
                      size="sm"
                      @click="showModalSlider = true"
                  >
                    <i class="mdi mdi-plus me-1"></i> Thêm sản phẩm
                  </b-button>
                  <b-modal
                      v-model = "showModalSlider"
                      title="Cập nhật sản phẩm sen"
                      title-class="text-black font-18"
                      body-class="p-3"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="lg"
                  >
                    <form @submit.prevent="handleSubmitSlider"
                          ref="formContainer"
                    >
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Tên sản phẩm</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.name"
                                id="percent"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.name.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.model.name.required"
                                class="invalid-feedback"
                            >
                              Tên sản phẩm không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Thứ tự</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.thuTu"
                                id="percent"
                                type="number"
                                class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Miêu tả</label>
                            <span style="color: red">&nbsp;*</span>
                            <textarea
                                v-model="model.mieuTa"
                                id="percent"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.mieuTa.$error,
                                }"
                            >
                            </textarea>
                            <div
                                v-if="submitted && !$v.model.mieuTa.required"
                                class="invalid-feedback"
                            >
                              Miêu tả không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Thành phần</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.thanhPhan"
                                id="percent"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.thanhPhan.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.model.thanhPhan.required"
                                class="invalid-feedback"
                            >
                              Thành phần không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Thương hiệu</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.thuongHieu"
                                id="percent"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.thuongHieu.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.model.thuongHieu.required"
                                class="invalid-feedback"
                            >
                              Thương hiệu không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Đánh giá</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.danhGia"
                                min="1"
                                max="5"
                                id="percent"
                                type="number"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.danhGia.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.model.danhGia.required"
                                class="invalid-feedback"
                            >
                              Đánh giá không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <label class="text-left mb-0 text-color">Link sản phẩm</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                v-model="model.link"
                                id="percent"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.model.link.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.model.link.required"
                                class="invalid-feedback"
                            >
                              Link sản phẩm không được trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="text-left mb-0 text-color">Doanh nghiệp sản xuất</label>
                            <span style="color: red">&nbsp;*</span>
                            <multiselect v-model="model.doanhNghiepSanXuat"
                                         :options="listDoanhNghiep"
                                         label="name"
                                         :multiple="false"
                                         selectLabel="Nhấn vào để chọn"
                                         deselectLabel="Nhấn vào để xóa"
                                         :class="{'is-invalid':submitted && $v.model.doanhNghiepSanXuat.$error,}"
                                         placeholder="Chọn doanh nghiệp sản xuất"
                                         >

                            </multiselect>
                            <div
                                v-if="submitted && !$v.model.doanhNghiepSanXuat.required"
                                class="invalid-feedback"
                            >
                              Doanh nghiệp sản xuất không được trống.
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="mb-2 ">
                            <label for="formFileSm" class="text-left mb-0 text-color">Ảnh đại diện</label>
                            <input
                                id="formFileSm"
                                name="file-input"
                                ref="fileInput"
                                type="file"
                                class="form-control"
                                @change="upload($event)"

                            />
                          </div>
                          <template  v-if="model.avartar" >
                            <a
                                class="ml-25"
                                :href="`${urlFile}/${model.avartar.fileId}`"
                            ><i
                                :class="`${getColorWithExtFile(model.avartar.ext)} me-2 ${getIconWithExtFile(model.avartar.ext)}`"
                            ></i>{{model.avartar.fileName }}</a>
                            <b-button
                                variant="flat-danger"
                                class="btn-icon"
                                @click="deleteImage()"
                            >
                              <i class="mdi mdi-trash-can-outline"></i>
                            </b-button>

                          </template>
                        </div>

                        <div class="col-md-12 mt-2">
                          <label class="text-left mb-0 text-color">File đính kèm</label>
                          <template  v-if="model.file.length > 0" >
                            <div v-for="(file,index) in model.file" :key="index">
                              <a
                                  class="ml-25"
                                  :href="`${urlFile}/${file.fileId}`"
                              ><i
                                  :class="`${getColorWithExtFile(file.ext)} me-2 ${getIconWithExtFile(file.ext)}`"
                              ></i>{{ file.fileName }}</a>
                              <b-button
                                  variant="flat-danger"
                                  class="btn-icon"
                                  @click="deleteFile(file.fileId)"
                              >
                                <i class="mdi mdi-trash-can-outline"></i>
                              </b-button>
                            </div>
                          </template>
                          <template>
                            <div>
                              <vue-dropzone
                                  id="dropzone"
                                  ref="myVueDropzone"
                                  :use-custom-slot="true"
                                  :options="dropzoneOptions"
                                  v-on:vdropzone-sending="sendingEvent"
                                  v-on:vdropzone-removed-file="removeThisFile"
                                  v-on:vdropzone-success="uploadFile"
                              >
                                <div class="dropzone-custom-content">
                                  <div class="mb-1">
                                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                  </div>
                                  <h4>Kéo thả tệp hoặc click vào đây để tải tệp tin.</h4>
                                </div>
                              </vue-dropzone>
                            </div>
                          </template>
                        </div>

                      </div>
                      <div class="text-end pt-2 mt-3">
                        <b-button variant="light" @click="showModalSlider = false" class="border-0">
                          Đóng
                        </b-button>
                        <b-button  type="submit" variant="success" class="ms-1 cs-btn-primary">Lưu
                        </b-button>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                        class="col-sm-12 d-flex justify-content-left align-items-center"
                    >
                      <div
                          id="tickets-table_length"
                          class="dataTables_length m-1"
                          style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                      "
                      >
                        <div class="me-1" >Hiển thị </div>
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            style="width: 70px"
                        ></b-form-select
                        >&nbsp;
                        <div style="width: 100px"> dòng </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables table-admin"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage-1)*perPage) + 1  }}
                    </template>
                    <template v-slot:cell(doanhNghiepSanXuat)="data">
                      <span style="margin-left: 5px">
                        {{ data.item.doanhNghiepSanXuat.name }}
                          </span>
                    </template>
                    <template v-slot:cell(avartar)="data">
                        <div v-if="data.item.avartar!=null">
                          <b-card-img
                              :src="url + data.item.avartar.fileId"
                              class="rounded-0 mb-2"
                              :height="300"
                              :width="300"
                          ></b-card-img>
                        </div>
                    </template>

                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm"
                          v-on:click="handleUpdate(data.item._id)">
                        <i class="fas fa-pencil-alt text-success me-1"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm"
                          v-on:click="handleShowDeleteModal(data.item._id)">
                        <i class="fas fa-trash-alt text-danger me-1"></i>
                      </button>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <b-col>
                    <div>Hiển thị {{numberOfElement}} trên tổng số {{totalRows}} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <b-modal
                v-model="showDeleteModal"
                centered
                title="Xóa dữ liệu"
                title-class="font-18"
                no-close-on-backdrop
            >
              <p>
                Dữ liệu xóa sẽ không được phục hồi!
              </p>
              <template #modal-footer>
                <button v-b-modal.modal-close_visit
                        class="btn btn-outline-info m-1"
                        v-on:click="showDeleteModal = false">
                  Đóng
                </button>
                <button v-b-modal.modal-close_visit
                        class="btn btn-danger btn m-1"
                        v-on:click="handleDelete">
                  Xóa
                </button>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

